import { toast } from 'sonner';
import { finishReceipt } from 'services/api/receipt';
import { useAuthStore } from 'store/authStore';
import { useReceiptStore } from 'store/receiptStore';
import { useTrackingStore } from 'store/trackingStore';
import { useAppStore } from 'store/appStore';
import { useProductStore } from 'store/productStore';
import { SCREEN_TYPES } from 'utils/constants';
import { resetAllProductRelatedStores } from 'utils/index';

export const closeCurrentReceipt = async (): Promise<boolean> => {
  const { user, stationId } = useAuthStore.getState();
  const { receiptData, setReceiptData } = useReceiptStore.getState();
  const { pendingTrackingId, setPendingTrackingId, setLastTrackingId, setCurrentTrackingId } =
    useTrackingStore.getState();
  const { setCurrentScreen } = useAppStore.getState();
  const { setCurrentProduct } = useProductStore.getState();

  const transactionId = receiptData?.transaction_id || receiptData?.receipt?.transaction_id;

  try {
    const result = await finishReceipt(transactionId, user?.id ?? '', stationId ?? '');

    if (result?.responseState === 'confirmed') {
      toast.success('Receipt closed successfully');
      setReceiptData(null);
      setCurrentProduct(null);
      setLastTrackingId(null);
      setPendingTrackingId(null);
      setCurrentTrackingId('');
      setCurrentScreen(SCREEN_TYPES.SCAN_BOX);
      if (!pendingTrackingId) {
        resetAllProductRelatedStores();
      }
      return true;
    } else {
      toast.error(result?.responseMsg || 'Failed to close receipt');
      return false;
    }
  } catch {
    toast.error('Network error. Please try again.');
    return false;
  }
};
